<template>
  <div class="sessions-list">
    <h2>{{ $t("reservation.availableSessions") }}</h2>
    <SessionsList
      :slots="slots"
      @update-sessions="updateSessions"
      :type="type"
    />
  </div>
</template>

<script>
import GlobalMixin from "@/GlobalMixin";
import moment from "moment";
import SessionsList from "../../components/NewReservation/SessionsList.vue";

export default {
  name: "SessionsView",
  mixins: [GlobalMixin],
  components: { SessionsList },
  data() {
    return {
      slots: [],
      windowInnerWidth : window.innerWidth,
    };
  },
  props: {
    id: {
      type: Number,
      default: null
    }
  },
  created() {
    this.getCalendarType()
  },
  methods: {
    /**
     * Get all available slots for a specifi tutor
     */
    getSessions(start_date, end_date,id) {
      const body = {
        start_date,
        end_date,
      };
      this.axios
        .post(
          `${process.env.VUE_APP_APIEndPoint}tutor/detail/${id}/`,
          body,
          this.headers
        )
        .then((res) => {
          const slots = [];
          Object.values(res.data.data.tutor.slots).forEach((day) =>
            day.forEach((slot) => slots.push(slot))
          );
          const exists = [];
          this.$store.getters.GET_SELECTED_SLOTS.forEach((slot) =>
            exists.push(slot.id)
          );
          this.slots = slots
            .map((slot) => {
              if (
                slot.scheduled_utc_end_date_time <
                moment(new Date()).format("yyyy-MM-DD HH:mm:ss")
              )
                return;
              const singleSession = {
                id: new Date(slot.scheduled_utc_start_date_time).getTime(),
                start: new Date(slot.scheduled_utc_start_date_time),
                end: new Date(slot.scheduled_utc_end_date_time),
                name:
                  slot.session_status[0].toUpperCase() +
                  slot.session_status.slice(1),
                color: this.slotColor(slot),
                timed: true,
                start_datetime: moment(slot.scheduled_utc_start_date_time),
                end_datetime: moment(slot.scheduled_utc_end_date_time),
                scheduled_utc_start_date_time:
                  slot.scheduled_utc_start_date_time,
                scheduled_utc_end_date_time: slot.scheduled_utc_end_date_time,
                reserved: false,
              };
              if (exists.includes(singleSession.id)) {
                singleSession.reserved = true;
                singleSession.color = "primary";
              }
              return singleSession;
            })
            .filter((slot) => slot);
        });
    },
    /**
     * Color slot based on session_status
     * @param slot 
     */
    slotColor(slot) {
      if(slot.session_status === "available") {
        return "#eff6ff"
      } else if(slot.session_status === "pending") {
        return "#e9b949";
      } else {
        return "#838e9e"
      }
    },
    /**
     * Update session and calendar
     * @param options calendar options object
     */
    updateSessions(options) {
      if (!options.start.date) return;
      const from_date = options.start.date;
      const to_date = options.end.date;
      this.type = options.type;
      if(this.id) {
        this.getSessions(from_date, to_date,this.id);
      } else {
        this.getSessions(from_date, to_date,this.$route.params.id);
      }
    },
    /**
     * Get calendar type based on window width
     */
    getCalendarType() {
      this.type = this.windowInnerWidth > 767 ? 'week' : 'day';
    }
  },
  /**
   * A guard to check if session is available before going to checkout page
   */
  beforeRouteLeave(to, from, next) {
    // To check availablity of slot when routing to Payment View
    if (to.name === "Payment") {
      const body = {
        program: this.$store.getters.GET_SELECTED_PROGRAM?.id,
        tutor: this.$route.params.id,
        student_available_time_slots: this.$store.getters.GET_SELECTED_SLOTS,
      };
      this.axios
        .post(
          `${process.env.VUE_APP_APIEndPoint}reserve/schedule/availability/`,
          body,
          this.headers
        )
        .then((res) => {
          if (!res.data.success)
            return this.showAlert(res.data.data.message, "error");

          next();
        })
        .catch((err) => this.formatErrors(err));
    } else {
      next();
    }
  },
};
</script>

<style lang="scss" scoped>
.sessions-list {
  margin-top: 36px;
  font-family: $font-family;
  font-style: normal;
  font-size: 16px;
  h2 {
    font-weight: 600;
    font-size: 1.25em;
    line-height: 1.4375em;
    color: $title;
    margin-bottom: 16px;
  }
}

@media all and (max-width: 768px) {
  .program-list {
    h2 {
      margin: 28px 0 16px;
    }
  }
}
</style>
